
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 141.7 141.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0066da","d":"M25.8 104.7l4.7 8.1c1 1.7 2.4 3 4 4l16.7-29H17.8c0 1.9.5 3.8 1.5 5.5l6.5 11.4z"}}),_c('path',{attrs:{"fill":"#ea4335","d":"M107.2 116.8c1.6-1 3-2.3 4-4l1.9-3.3 9.3-16.1c1-1.7 1.5-3.6 1.5-5.5H90.5l7.1 14 9.6 14.9z"}}),_c('path',{attrs:{"fill":"#00832d","d":"M70.9 53.8l16.7-29c-1.6-1-3.5-1.5-5.5-1.5H59.6c-1.9 0-3.8.5-5.5 1.5l16.8 29z"}}),_c('path',{attrs:{"fill":"#2684fc","d":"M90.5 87.9H51.2l-16.7 29c1.6 1 3.5 1.5 5.5 1.5h61.8c1.9 0 3.8-.5 5.5-1.5l-16.8-29z"}}),_c('path',{attrs:{"fill":"#ffba00","d":"M107.1 55.7L91.6 28.9c-1-1.7-2.4-3-4-4l-16.7 29L90.5 88h33.4c0-1.9-.5-3.8-1.5-5.5l-15.3-26.8z"}}),_c('path',{attrs:{"fill":"#00ac47","d":"M19.2 82.4c-1 1.7-1.5 3.6-1.5 5.5h33.4l19.6-34.1-16.7-29c-1.6 1-3 2.3-4 4L34.6 55.7 19.2 82.4z"}})])
          )
        }
      }
    